import { SemaphoreFormType } from "app/traffic-lights-management/types/types";
import { trafficLightOptions } from "app/traffic-lights-management/utils/data";
import clsx from "clsx";
import { FC } from "react";

interface TrafficLightInputsProps {
    data: SemaphoreFormType;
    readOnly?: boolean;
    onChange?: (color_key: string, value: number) => void;
}

const TrafficLightInputs: FC<TrafficLightInputsProps> = ({ data, readOnly = false, onChange }) => {
    const handleChange = (color_key: string, val: string) => {
        if (!onChange) return;
        const numericValue = val.replace(/[^0-9]/g, '');
        onChange(
            color_key,
            numericValue === '' ? 0 : parseInt(numericValue, 10)
        );
    };

    return (
        <div className="flex gap-2  p-2 rounded-lg border border-borderInputSection shadow-sm bg-bgInputSection">
            {trafficLightOptions.map((item, index) => (
                <div key={item.color_key} className="flex flex-col items-center">
                    <div className={clsx("w-3 h-3 rounded-full mb-1", item.label)} />
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        disabled={readOnly}
                        className="w-8 text-center text-xs font-bold border rounded p-1 focus:outline-none focus:ring-1 focus:ring-blue-400"
                        value={data.semaphore_levels[index]?.threshold_minutes || 0}
                        onChange={(e) => handleChange(item.color_key, e.target.value)}
                    />
                </div>
            ))}
        </div>
    );
};

export default TrafficLightInputs;